<template>
  <div class="tableWithPerPageSelection">
    <error-msg-component :messages="messagesErreur"
                          :error="isError"
                          :title="'general.problemOccurred'"
                          @close="isError = $event"/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options="actions"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllProduiReseauTempoSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeProduitReseauTempo.actions.search')"
                     type="search"
                     v-model="criteresRecherche.auto"
                     icon="magnify">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeProduitReseauTempo.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <exportExcelButton
            v-if="!isSelection && !isMultiType"
            class="mgr-2"
            :perm="permCatalogue.exporter"
            :query="exportExcelQuery"/>
        <vertical-dots-dropdown
            v-if="!isSelection && isOnlyReseauTempo"
            class="mgr-2"
            :dropdownItems="exportDotsItems"
            isButton/>
        <parametrage-table
          v-if="!isSelection"
          :reference-table="referenceTable"
          @endLoadParamtre="endLoadParametre = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table
        v-if="startArrayRendering && (isSelection || endLoadParametre)"
        url=""
        :columns="columns"
        :options="options"
        @loaded="finLoading"
        @loading="debutLoading"
        :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template slot="selected" slot-scope="props">
        <div class="has-text-centered">
            <qd-checkbox v-model="props.row.selected"
                        :value="props.row">
            </qd-checkbox>
        </div>
      </template>
      <template slot="reference" slot-scope="props">
        <router-link
            v-if="getRouteDetailTo(props.row)"
            class="lien"
            :to="getRouteDetailTo(props.row)"
            :class="{'text-access-no-permission': !checkPermissions(permCatalogue.lecture)}">
          {{ props.row.reference }}
        </router-link>
      </template>
      <template slot="format" slot-scope="{ row }">
        {{ getFormatLibelle(row) }}
      </template>
      <template slot="nbFacesReelles" slot-scope="{ row }">
        <div class="is-pulled-right">
          {{ getNbFacesReelles(row) }}
        </div>
      </template>
      <template slot="nbFacesPrevues" slot-scope="props">
        <div class="is-pulled-right">
          {{ props.row.nbFacesPrevues }}
        </div>
      </template>
      <template slot="typeReseau" slot-scope="{ row }">
        {{ getTypeReseauLibelle(row) }}
      </template>
      <template slot="societe" slot-scope="props">
        {{ getLibelleSociete(props.row.supportCommercial.societeId) }}
      </template>
      <template slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId) }}
      </template>
      <template slot="ville" slot-scope="{ row }">
        {{ getVille(row) }}
      </template>
      <template slot="regroupementProduit" slot-scope="props">
        <router-link-blank
            v-if="props.row.regroupementProduit"
            :to="{
                name: 'c.bodac.catalogue-detailRegroupementProduit',
                params: {
                  id: props.row.regroupementProduit.id,
                }
            }"
            :message="props.row.regroupementProduit.code"/>
      </template>
      <template slot="actif" slot-scope="props">
        {{ getLibelleActif(props.row.actif) }}
      </template>
      <template slot="exporter" slot-scope="props" >
        <btn-action-icon
            :tooltipLabel="$t('general.button.export')"
            icon="file-pdf-box"
            :permission="permCatalogue.editer"
            :key="props.id"
            @is-click="editionProduit(props.row)"
        />
      </template>
      <template slot="edit" slot-scope="{ row }">
        <btn-action-icon
            icon="pencil-box-outline"
            :tooltipLabel="$t('general.button.edit')"
            :permission="permCatalogue.maj"
            :key="row.id"
            iconType="is-success"
            :disabled="isModifiableIntoHolding(row)"
            @is-click="$router.push(getRouteEditTo(row))"
        />
      </template>
      <template slot="archiver" slot-scope="{ row }">
        <btn-action-icon
            :icon="row.actif ? 'archive' : 'archive-arrow-up'"
            :tooltipLabel="$t(`general.button.${row.actif ? 'archiver': 'desarchiver'}`)"
            :permission="permCatalogue.supprimer"
            :key="row.id"
            iconType="is-default"
            :disabled="isModifiableIntoHolding(row)"
            @is-click="openPopUpArchivage(row)"
        />
      </template>
      <template slot="delete" slot-scope="props">
        <btn-action-icon
            :tooltipLabel="$t('general.button.delete')"
            icon="delete-forever"
            :permission="permCatalogue.supprimer"
            :key="props.id"
            iconType="is-danger"
            :disabled="isModifiableIntoHolding(props.row)"
            @is-click="openPopUpDelete(props.row)"
        />
      </template>
      <template slot="addSelection" slot-scope="props">
        <button
          @click="$emit(
            isInSelection(props.row) ? 'removeSelection' : 'addSelection',
            [formatReseauWithDate(props.row)],
          )"
          class="ripple button width-100percent"
          :class="isInSelection(props.row) ? 'is-success' : 'is-primary'">
          <b-icon icon="plus-circle"></b-icon>
        </button>
      </template>
    </v-server-table>
    <b-modal v-model="popUpDelete" has-modal-card
      class="modal" v-if="produitToDelete">
      <pop-up-prevention
        :mess-header="$t('suppressionProduitReseau.suppression.supprimer')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :is-error-popup="errorPopUp"
        :messages-popup="messagesPopup"
        @yes="supprimerProduit"
        @no="popUpDelete = false">
      </pop-up-prevention>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-produit-reseau-tempo
            ref="filtreListeProduitReseauTempo"
            :storeName="storeName"
            @toggleFiltre="setShowFiltre"
            @recherche="makeRechercheFilter()"
        />
      </div>
    </transition>
    <b-modal v-model="popUpArchivage"
             has-modal-card
             class="modal" @close="produitToArchive = null">
      <pop-up-prevention v-if="produitToArchive"
                        :messHeader="$t(produitToArchive.actif
                        ? 'listeProduitReseauTempo.archivage.archiver'
             : 'listeProduitReseauTempo.archivage.desarchiver')"
                        :cancel="$t('listeProduitReseauTempo.archivage.no')"
                        :validate="$t('listeProduitReseauTempo.archivage.yes')"
                        @no="popUpArchivage = false"
                        @yes="archiverProduit()"/>
    </b-modal>
    <b-modal
      v-model="popUpImportExcel"
      has-modal-card
      class="modal">
      <pop-up-import-excel :title="$t('listeProduitReseauTempo.popUpImportExcelTitle')"/>
    </b-modal>
    <b-modal
      v-model="popUpEditionPlanning"
      has-modal-card
      class="modal">
      <pop-up-editer-planning-reseau-tempo @editionPlanning="editionPlanning">
      </pop-up-editer-planning-reseau-tempo>
    </b-modal>
    <b-modal
      v-model="popUpActionSecteur"
      has-modal-card
      class="modal"
      width="600px">
      <pop-up-manage-secteur
        :secteur-type="constantes.COMMERCIAL"
        :items-ids="getAllProduiReseauTempoSelected().map(el => el.id)"
        :action-secteur="actionSecteur"
        :is-add="actionSelected === constantes.ACTION_MASS_AJOUTER_SECTEUR"
        :translator="func.translatorSecteurProduits"
        :refresh="recherche"
        :validation="func.validationSecteur"
        @close="popUpActionSecteur = false"
      />
    </b-modal>
  </div>
</template>

<script>

import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import messageErreur from '@/services/general/messageErreur';
import {
  archiver as archiverReseauTempo,
  ajoutSecteurAsync, supprimerSecteurAsync,
  deleteReseau as deleteReseauTempo,
} from '@/api/produit/produitReseau';
import { archiver as archiverReseauLc, deleteReseau as deleteReseauLc } from '@/api/produit/produitReseauLc';
import { archiver as archiverReseauMairie, deleteReseau as deleteReseauMairie } from '@/api/produit/produitReseauMairie';
import validationDelete from '@/services/catalogue/validation/validationProduit';
import messageSucces from '@/services/general/messageSucces';
import inProgress from '@/services/general/inProgress';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import popUpPrevention from '@/components/general/popUpPrevention';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import filtreListeProduitReseauTempo from '@/components/catalogue/filtre/filtreListeProduitReseauTempo';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import edition from '@/api/edition';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import {
  TYPE_EDITION_RESEAU,
  TYPE_EDITION_RESEAU_LC,
  CATEGORIE_LOCATION,
  CATEGORIE_DIVERS,
  EXPORT_EXCEL_OBJECTIF_RESEAU_TEMPO_PRODUIT,
  EXPORT_EXCEL_PRODUIT_RESEAU_TEMPO,
  ACTION_PLANNING_RESEAU_TEMPO,
  TYPE_EDITION_PLANNING_RESEAU,
  ACTION_EXPORT_FACES_RESEAU_TEMPO,
  FACES_RESEAUX_SELECTIONEES,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';
import {
  ACTION_MASS_AJOUTER_SECTEUR,
  ACTION_MASS_SUPPRIMER_SECTEUR,
} from '@/configuration/general/actionsConf';
import exportExcel from '@/api/exportExcel';
import formatDate from '@/services/general/formatIsoDate';
import popUpImportExcel from '@/components/catalogue/p_importExcel';
import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import popUpEditerPlanningReseauTempo
  from '@/components/bodac/produit/reseauTempo/p_editerPlanningReseauTempo';
import validationEdition from '@/services/general/validation/validationRetourEdition';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import { columnsSplice } from '@/services/general/columns';
import parametrageTable from '@/components/general/parametrageTable';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { ACTION_ADD_SELECTION, ACTION_DELETE_SELECTION } from '@/configuration/cartographie/cartographie';
import popUpManageSecteur from '@/components/commun/secteur/p_manageSecteur';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import translatorSecteurProduits from '@/services/secteur/translatorSecteurProduits';
import { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';
import btnActionIcon from '@/components/general/btnActionIcon';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import validationSecteur from '@/services/commun/secteur/validationSecteur';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Societes = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Attachments = createNamespacedHelpers('attachments');

export default {
  props: {
    typeReseau: {
      type: Array,
      required: true,
    },
    referenceTable: {
      type: String,
      required: true,
    },
    storeName: {
      type: String,
      required: true,
    },
    selection: {
      type: Array,
      default: () => [],
    },
    isSelection: {
      type: Boolean,
      default: false,
    },
    permCatalogue: {
      type: Object,
      default: () => CATALOGUE,
    },
  },
  data() {
    return {
      showFiltre: false,
      produitToArchive: null,
      popUpArchivage: false,
      popUpDelete: false,
      produitToDelete: null,
      popUpActionSecteur: false,
      actionSelected: null,
      unsubscribeValue: null,
      startArrayRendering: false,
      exportObjectifs: EXPORT_EXCEL_OBJECTIF_RESEAU_TEMPO_PRODUIT,
      popUpImportExcel: false,
      popUpEditionPlanning: false,
      messagesErreur: [],
      errorPopUp: false,
      messagesPopup: [],
      isError: false,
      endLoadParametre: false,
      resultPerPage: RESULTS_PER_PAGE,
      constantes: {
        COMMERCIAL,
        ACTION_MASS_AJOUTER_SECTEUR,
        TYPE_PDF,
      },
      func: {
        validationSecteur,
        translatorSecteurProduits,
      },
    };
  },
  components: {
    selecteurAction,
    TableItemsInView,
    popUpPrevention,
    filtreListeProduitReseauTempo,
    popUpImportExcel,
    popUpEditerPlanningReseauTempo,
    errorMsgComponent,
    parametrageTable,
    routerLinkBlank,
    exportExcelButton,
    popUpManageSecteur,
    btnActionIcon,
    verticalDotsDropdown,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societes.mapGetters({
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
      agenceActive: 'agenceActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    produitsReseau() {
      return this.$store.getters[`${this.storeName}/items`];
    },
    totalCount() {
      return this.$store.getters[`${this.storeName}/total`];
    },
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE`, value);
      },
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    isOnlyReseauTempo() {
      return this.typeReseau.includes(CATEGORIE_REGROUPEMENT)
      && this.typeReseau.length === 1;
    },
    isOnlyReseauMairie() {
      return this.typeReseau.includes(CATEGORIE_REGROUPEMENT_MAIRIE)
      && this.typeReseau.length === 1;
    },
    isMultiType() {
      return this.typeReseau.length > 1;
    },
    actions() {
      const actions = [];
      if (this.isSelection) {
        actions.push({ action: ACTION_ADD_SELECTION, translation: 'cartographie.actions.addSelection' });
        actions.push({ action: ACTION_DELETE_SELECTION, translation: 'cartographie.actions.removeSelection' });
        return actions;
      }
      if (this.isOnlyReseauTempo) {
        actions.push({ action: ACTION_PLANNING_RESEAU_TEMPO, translation: 'listeProduitReseauTempo.actions.planning' });
        actions.push({
          action: ACTION_EXPORT_FACES_RESEAU_TEMPO,
          translation: 'listeProduitReseauTempo.actions.exporterFacesReseaux',
        });
        if (this.moduleSecteurActive) {
          actions.push({ action: ACTION_MASS_AJOUTER_SECTEUR, translation: 'addSecteurLien.actions.addSecteur' });
          actions.push({ action: ACTION_MASS_SUPPRIMER_SECTEUR, translation: 'addSecteurLien.actions.deleteSecteur' });
        }
        return actions;
      }
      return actions;
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeProduitReseauTempo.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProduitReseauTempo.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    iconSelectTotal() {
      if (this.allProduiReseauTempoSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allProduiReseauTempoSelected() {
      return this.getAllProduiReseauTempoSelected().length === this.produitsReseau.length
        && this.produitsReseau.length > 0;
    },
    nombreCritere() {
      let nbCritere = calculNombreCritere(this.criteresRecherche, ['auto', 'actif', 'hasSecteur', 'categories']);
      if (!this.criteresRecherche.hasSecteur
        && this.criteresRecherche.hasSecteur !== null
        || this.criteresRecherche.hasSecteur) nbCritere += 1;
      if (this.criteresRecherche.actif !== null) nbCritere += 1;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = [
        'selected', 'addSelection', 'reference', 'libelle', 'ville', 'format', 'typeReseau', 'nbFacesPrevues',
        'nbFacesReelles', 'agence', 'societe', 'regroupementProduit',
        'actif', 'exporter', 'edit', 'archiver', 'delete',
      ];
      if (this.user.agences.length <= 1) {
        columnsSplice(columns, 'agence');
      }
      if (this.societesInformations.length === 1 || this.filtrerProduitParSociete
        || this.filtrerProduitParAgence) {
        columnsSplice(columns, 'societe');
      }
      if (!this.modulePresseActive) {
        columnsSplice(columns, 'regroupementProduit');
      }
      if (this.isSelection) {
        columnsSplice(columns, 'exporter');
        columnsSplice(columns, 'edit');
        columnsSplice(columns, 'archiver');
        columnsSplice(columns, 'delete');
      } else {
        columnsSplice(columns, 'addSelection');
      }
      if (this.isOnlyReseauMairie) {
        columnsSplice(columns, 'nbFacesPrevues');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('listeProduitReseauTempo.tabs.reference'),
          libelle: this.$i18n.t('listeProduitReseauTempo.tabs.libelle'),
          societe: this.$i18n.t('listeProduitReseauTempo.tabs.societe'),
          ville: this.$i18n.t('listeProduitReseauTempo.tabs.ville'),
          format: this.$i18n.t('listeProduitReseauTempo.tabs.format'),
          typeReseau: this.$i18n.t('listeProduitReseauTempo.tabs.type'),
          nbFacesPrevues: this.$i18n.t('listeProduitReseauTempo.tabs.nbFacesPrevues'),
          nbFacesReelles: this.$i18n.t('listeProduitReseauTempo.tabs.nbFacesReelles'),
          agence: this.$i18n.t('listeProduitReseauTempo.tabs.agence'),
          regroupementProduit: this.$i18n.t('listeProduitFace.tabs.regroupementProduit'),
          actif: this.$i18n.t('listeProduitReseauTempo.tabs.actif'),
          addSelection: '',
          edit: '',
          archiver: '',
          delete: '',
          exporter: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['reference', 'libelle', 'ville', 'format', 'typeReseau', 'actif'],
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          exporter: 'colonneSelected',
          addSelection: 'colonneSelected-35 is-paddingless',
        },
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          if (this.user.agences.length === 1) {
            data.query.agencesId = [this.user.agences[0].agenceId];
          }
          return this.loadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produitsReseau,
            count: this.totalCount,
          };
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_PRODUIT_RESEAU_TEMPO,
        typeExport: this.typeReseau[0],
        filtres: transform(this.lastPayload),
      };
    },
    actionSecteur() {
      if (this.actionSelected === ACTION_MASS_AJOUTER_SECTEUR) return ajoutSecteurAsync;
      return supprimerSecteurAsync;
    },
    exportDotsItems() {
      return [
        {
          libelle: this.$t('listeProduitReseauTempo.actions.exporterObjectif'),
          permission: this.permCatalogue.exporter,
          action: this.exportExcelObjectifs,
        },
        {
          libelle: this.$t('listeProduitReseauTempo.actions.importerObjectif'),
          permission: this.permCatalogue.exporter,
          action: () => { this.popUpImportExcel = true; },
        },
      ];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societes.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societes.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
    }),
    loadProduits(data) {
      return this.$store.dispatch(`${this.storeName}/loadProduits`, data);
    },
    isInSelection(row) {
      return this.selection?.find(f => f.id === row.id);
    },
    formatReseauWithDate(row) {
      const reseau = cloneDeep(row);
      reseau.dateSelection = this.criteresRecherche.dateVisualisation;
      return reseau;
    },
    isModifiableIntoHolding(produit) {
      return produit.supportCommercial.societeId !== this.societeActiveId
          && produit.supportCommercial.categorieVente !== CATEGORIE_LOCATION
          && produit.supportCommercial.categorieVente !== CATEGORIE_DIVERS;
    },
    editionProduit(row) {
      switch (row?.supportCommercial?.categorieVente) {
        case CATEGORIE_REGROUPEMENT:
          this.edition({
            format: this.constantes.TYPE_PDF,
            ids: [row.id],
            typeDonnee: TYPE_EDITION_RESEAU,
          });
          break;
        case CATEGORIE_REGROUPEMENT_LC:
          this.edition({
            format: this.constantes.TYPE_PDF,
            ids: [row.id],
            typeDonnee: TYPE_EDITION_RESEAU_LC,
            parametresAdditionnels: {
              dateVisu: formatDate(this.criteresRecherche.dateVisualisation),
              typeSource: 'reseauLc',
              societeId: this.societeActiveId,
            },
          });
          break;
        default:
          this.inProgress();
          break;
      }
    },
    editionPlanning(parametres, format) {
      this.popUpEditionPlanning = false;
      this.edition({
        ids: this.getAllProduiReseauTempoSelected().map(el => el.id),
        format: format,
        typeDonnee: TYPE_EDITION_PLANNING_RESEAU,
        parametresAdditionnels: parametres,
      });
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreur = [];
        this.isError = false;
        const response = await edition({
          ids: donnees.ids,
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEdition(response, this.messagesErreur);
          this.isError = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeProduitReseauTempo.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getVille(row) {
      return row.produitReseauNumerique?.adresse?.ville ?? row.produitReseau?.adresse?.ville;
    },
    getAgenceLibelle(agenceId) {
      const agenceFind = this.agencesInformations.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
    getNbFacesReelles(p) {
      if (p.produitReseau) {
        return p.produitReseau.affectationsReseauFace?.length ?? 0;
      }
      if (p.produitReseauNumerique) {
        return p.produitReseauNumerique.affectationsReseauEcran?.length ?? 0;
      }
      return 0;
    },
    getFormatLibelle(p) {
      const formatId = p.produitReseauNumerique?.formatId ?? p.produitReseau?.formatId;
      if (!formatId) return '';
      const formatFind = this.parametre(PARAMETRES_KEYS.format).find((format) => {
        return format.id === formatId;
      });
      return formatFind?.libelle ?? '';
    },
    getTypeReseauLibelle(p) {
      const typeId = p.produitReseauNumerique?.typeReseauId ?? p.produitReseau?.typeReseauId;
      if (!typeId) return '';
      const typeReseauFind = this.parametre(PARAMETRES_KEYS.typeReseau).find((typeReseau) => {
        return typeReseau.id === typeId;
      });
      return typeReseauFind?.libelle ?? '';
    },
    getAllProduiReseauTempoSelected() {
      return this.produitsReseau.filter((el) => { return el.selected; });
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    getRouteDetailTo(row) {
      switch (row?.supportCommercial?.categorieVente) {
        case CATEGORIE_REGROUPEMENT:
          return {
            name: 'c.bodac.catalogue-reseau',
            params: {
              id: row.id,
              isFromListeProduitReseau: true,
            },
          };
        case CATEGORIE_REGROUPEMENT_LC:
          return {
            name: 'c.bodac.catalogue-reseauLc',
            params: {
              id: row.id,
              isFromListeProduitReseauLc: true,
            },
          };
        case CATEGORIE_REGROUPEMENT_MAIRIE:
          return {
            name: 'c.bodac.catalogue-reseauMairie',
            params: {
              id: row.id,
              isFromListeProduitReseauMairie: true,
            },
          };
        case CATEGORIE_REGROUPEMENT_NUMERIQUE:
          return {
            name: 'c.bodac.catalogue-reseauNumerique',
            params: {
              id: row.id,
              isFromListeProduitReseauNum: true,
            },
          };
        default:
          return null;
      }
    },
    getRouteEditTo(row) {
      switch (row?.supportCommercial?.categorieVente) {
        case CATEGORIE_REGROUPEMENT:
          return {
            name: 'm.bodac.catalogue-editionReseau',
            params: {
              produitId: row.id,
              isFromListeProduitReseau: true,
            },
          };
        case CATEGORIE_REGROUPEMENT_LC:
          return {
            name: 'm.bodac.catalogue-editionReseauLc',
            params: {
              produitId: row.id,
              isFromListeProduitReseauLc: true,
            },
          };
        case CATEGORIE_REGROUPEMENT_MAIRIE:
          return {
            name: 'm.bodac.catalogue-editionReseauMairie',
            params: {
              produitId: row.id,
              isFromListeProduitReseauMairie: true,
            },
          };
        default:
          return null;
      }
    },
    archiver(produit) {
      switch (produit?.supportCommercial?.categorieVente) {
        case CATEGORIE_REGROUPEMENT:
          return archiverReseauTempo;
        case CATEGORIE_REGROUPEMENT_LC:
          return archiverReseauLc;
        case CATEGORIE_REGROUPEMENT_MAIRIE:
          return archiverReseauMairie;
        default:
          return () => {};
      }
    },
    delete(produit) {
      switch (produit?.supportCommercial?.categorieVente) {
        case CATEGORIE_REGROUPEMENT:
          return deleteReseauTempo;
        case CATEGORIE_REGROUPEMENT_LC:
          return deleteReseauLc;
        case CATEGORIE_REGROUPEMENT_MAIRIE:
          return deleteReseauMairie;
        default:
          return () => {};
      }
    },
    async archiverProduit() {
      this.popUpArchivage = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const archiverReseau = this.archiver(this.produitToArchive);
        await archiverReseau(this.produitToArchive.id, this.produitToArchive.actif);
        messageSucces(this.$i18n.t(this.produitToArchive.actif
          ? 'listeProduitReseauTempo.archivage.sucessArchivage'
          : 'listeProduitReseauTempo.archivage.successDesarchivage'));
        this.produitToArchive = null;
        this.recherche();
      } catch (e) {
        this.produitToArchive = null;
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async supprimerProduit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const deleteReseau = this.delete(this.produitToDelete);
        await deleteReseau(this.produitToDelete.id);
        messageSucces(this.$i18n.t('suppressionProduitReseau.suppression.successDelete'));
        this.produitToArchive = null;
        this.popUpDelete = false;
        this.recherche();
      } catch (e) {
        this.produitToArchive = null;
        if (e.response.data.error) {
          this.errorPopUp = true;
          this.messagesPopup = validationDelete(e.response);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    openPopUpArchivage(produit) {
      this.produitToArchive = produit;
      this.popUpArchivage = true;
    },
    openPopUpDelete(produit) {
      this.produitToDelete = produit;
      this.popUpDelete = true;
      this.messagesPopup = [];
      this.errorPopUp = false;
    },
    selectAll() {
      const select = !this.allProduiReseauTempoSelected;
      this.produitsReseau.forEach((el) => {
        el.selected = select;
      });
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    updateAgenceAndRecherche() {
      if (this.filtrerProduitParAgence) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.recherche();
    },
    getLibelleActif(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    async reinitialiser() {
      await this.$refs.filtreListeProduitReseauTempo.initializeFiltre();
      this.$refs.filtreListeProduitReseauTempo.viderCritere();
      this.$refs.filtreListeProduitReseauTempo.appliquerCritere();
      this.showFiltre = false;
    },
    handleAction(action) {
      this.actionSelected = action;
      switch (action) {
        case ACTION_PLANNING_RESEAU_TEMPO:
          if (this.checkPermissions(this.permCatalogue.editer)) {
            this.popUpEditionPlanning = true;
          } else this.showPopUp();
          break;
        case ACTION_ADD_SELECTION:
          this.$emit('addSelection', this.produitsReseau.filter((el) => { return el.selected; }).map(el => this.formatReseauWithDate(el)));
          break;
        case ACTION_DELETE_SELECTION:
          this.$emit('removeSelection', this.produitsReseau.filter((el) => { return el.selected; }).map(el => this.formatReseauWithDate(el)));
          break;
        case ACTION_EXPORT_FACES_RESEAU_TEMPO:
          this.exportFacesReseauxSelectionnes();
          break;
        case ACTION_MASS_AJOUTER_SECTEUR:
        case ACTION_MASS_SUPPRIMER_SECTEUR:
          if (this.checkPermissions(this.permCatalogue.maj)) {
            this.popUpActionSecteur = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFactures.error.noActionSelect'));
          break;
      }
    },
    async exportExcelObjectifs() {
      const fullYear = moment(this.lastPayload.query.dateVisualisation).year();
      const lastWeeksInYear = Math.max(
        moment(new Date(fullYear, 11, 31)).isoWeek(),
        moment(new Date(fullYear, 11, 31 - 7)).isoWeek(),
      );
      const dateDebut = moment(fullYear.toString() + '01', 'GGGGWW').startOf('week').toDate();
      const dateFin = moment(fullYear.toString() + lastWeeksInYear, 'GGGGWW').startOf('week').toDate();
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: this.exportObjectifs,
          typeExport: null,
          filtres: transform({
            ...this.lastPayload,
            query: {
              ...this.lastPayload.query,
              dateDebut: formatDate(dateDebut),
              dateFin: formatDate(dateFin),
            },
          }),
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async exportFacesReseauxSelectionnes() {
      const facesSelectionnees = this.getAllProduiReseauTempoSelected();
      if (facesSelectionnees.length === 0) {
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: FACES_RESEAUX_SELECTIONEES,
          typeExport: null,
          filtres: transform({
            query: {
              produitsIds: facesSelectionnees
                .map(pr => pr.produitReseau?.id),
              dateVisualisation: this.criteresRecherche.dateVisualisation,
            },
          }),
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  beforeDestroy() {
    if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
      this.unsubscribeValue();
    }
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Reseau' });
      await this.loadSocietes({});
      await this.loadParametres([PARAMETRES_KEYS.format, PARAMETRES_KEYS.typeReseau]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
      ]);
      if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      }
      if (this.user.agences.length > 1) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      if (this.moduleSecteurActive) {
        const targetSecteur = await getSecteursByIds(this.user.secteursId, COMMERCIAL);
        if (targetSecteur.length > 0) {
          this.criteresRecherche.secteurIds = targetSecteur.map(ts => ts.id);
        }
      }
      if (this.criteresRecherche.formats?.length) {
        const formatsActifs = this.parametre(PARAMETRES_KEYS.format)
          .filter(format => format.actif);
        this.criteresRecherche.formats = this.criteresRecherche.formats
          .filter(id => formatsActifs.find(f => f.id === id));
      }
      this.startArrayRendering = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
